import { render, staticRenderFns } from "./account-patch-phone.vue?vue&type=template&id=5cc38811&"
import script from "./account-patch-phone.vue?vue&type=script&lang=js&"
export * from "./account-patch-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports